import React from 'react'
import { Table } from 'react-bootstrap'

const TableHeader = ({
  tableName,
  isOrganizationTable,
}: {
  tableName: string
  isOrganizationTable: boolean
}) => {
  const headerTitles = [
    'id',
    'name',
    'logo',
    ...(isOrganizationTable ? ['status'] : []),
    'link',
  ]
  return (
    <>
      {headerTitles.map((title) => (
        <th key={title} className="modern-table-header-cell">
          {tableName} {title}
        </th>
      ))}
    </>
  )
}

interface Data {
  id: string //
  name: string
  visible_logo_url: string
  badge_logo_url: string
  organization_id: string
  active?: boolean
}

const TableBody = ({
  data,
  link,
  parentData,
  showStatus,
  isFirstRow,
  tableName,
}: {
  data: Data
  link: string
  parentData?: { active?: boolean }
  showStatus?: boolean
  isFirstRow?: boolean
  tableName: string
}) => {
  return (
    <tr
      key={data.id}
      className={
        isFirstRow ? 'modern-table-first-row' : 'modern-table-row-border'
      }
    >
      <td className="modern-table-body-cell">{data.id}</td>
      <td className="modern-table-body-cell">{data.name}</td>
      <td className="modern-table-body-cell">
        <img
          src={data.visible_logo_url || data.badge_logo_url}
          alt={data.visible_logo_url || data.badge_logo_url}
          style={{
            maxWidth: 'clamp(40px, 8vw, 90px)',
            height: 'auto',
          }}
        />
      </td>
      {showStatus && (
        <td className="modern-table-body-cell">
          <span
            className={`badge ${
              parentData?.active ? 'bg-success' : 'bg-danger'
            }`}
            style={{ fontSize: '0.75rem', padding: '0.5em 1em' }}
          >
            {parentData?.active ? 'Active' : 'Inactive'}
          </span>
        </td>
      )}
      <td className="modern-table-body-cell">
        <a
          href={`/${link}`}
          target="_blank"
          rel="noreferrer"
          className="btn btn-sm btn-success"
          style={{
            fontSize: 'clamp(10px, 2vw, 12px)',
            padding: '4px 8px',
            textDecoration: 'none',
            whiteSpace: 'nowrap',
          }}
        >
          Go to {tableName}
        </a>
      </td>
    </tr>
  )
}

const UserOrgTeamTable = ({
  tableName,
  tableBodyData,
  tableBodyDataKey,
  link,
}: {
  tableName: string
  tableBodyData: Record<string, Data>[]
  tableBodyDataKey: number | string
  link: string
}) => {
  const isOrganizationTable = tableName.toLowerCase().includes('organization')

  const sortedData = [...tableBodyData].sort((a, b) => {
    const aActive = a.active ? 1 : 0
    const bActive = b.active ? 1 : 0
    return bActive - aActive
  })

  return (
    <Table responsive variant="dark" className="modern-table">
      {tableBodyData.length > 0 ? (
        <>
          <thead>
            <tr className="modern-table-header-row">
              <TableHeader
                tableName={tableName}
                isOrganizationTable={isOrganizationTable}
              />
            </tr>
          </thead>
          <tbody>
            {sortedData?.map((data, index) => (
              <TableBody
                key={`${data[tableBodyDataKey].id}-${index}`}
                data={data[tableBodyDataKey]}
                parentData={data}
                showStatus={isOrganizationTable}
                isFirstRow={index === 0}
                link={
                  link === 'team'
                    ? `organizations/${data?.[tableBodyDataKey]?.organization_id}/teams/${data?.[tableBodyDataKey]?.id}`
                    : `organizations/${data?.[tableBodyDataKey]?.id}`
                }
                tableName={tableName}
              />
            ))}
          </tbody>
        </>
      ) : (
        <thead>
          <tr className="modern-table-header-row">
            <td className="modern-table-body-cell">{`No ${tableName} Associated With This User`}</td>
          </tr>
        </thead>
      )}
    </Table>
  )
}

export default UserOrgTeamTable
